import { combineReducers } from '@ngrx/store';
import { EntryCyclesView } from '../../../_generated';
import { EntryCyclesRequestStatusAction } from '../../actionstypes/entry-cycles/entry-cycles-request-status.actiontype';
import { RequestStatus } from '../../actionstypes/request-status/request-status.actiontype';
import requestStatusReducer from '../request-status/request-status.reducer';
import { entryCyclesReducer } from './entry-cycles.reducer';

export interface RootEntryCycles {
  requestStatus: RequestStatus;
  data: EntryCyclesView[];
}

export const entryCyclesRootReducer = combineReducers({
  requestStatus: requestStatusReducer(
    EntryCyclesRequestStatusAction.Load,
    EntryCyclesRequestStatusAction.Success,
    EntryCyclesRequestStatusAction.Error,
  ),
  data: entryCyclesReducer,
});
